import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLeadStore, useSaleCompStore } from '../..';
import useCircleWithRadius from '../../hooks/useCircleWithRadius';
import useCircleWithRadiusOnMap from '../../hooks/useCircleWithRadiusOnMap';
import useSaleCompsWithFocusArea from '../../hooks/useSaleCompsWithFocusArea';
import useSaleCompsWithGlobalFilters from '../../hooks/useSaleCompsWithGlobalFilters';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { formatNumber } from '../../utils/utils';
import RadiusDropdown from '../RadiusDropdown';
import SaleCompsGrid from '../saleComps/SaleCompsGrid';

function LeadDetailsSaleCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leadStore = useLeadStore();
    const saleCompStore = useSaleCompStore();
    const lead = useMemo(() => computed(() => leadStore.leads.find(l => l.id.toString() === id)!), [id]).get();
    const [radius, setRadius] = useState(5);
    const circle = useCircleWithRadius(lead.centerPoint, radius)!;
    useCircleWithRadiusOnMap(lead.centerPoint, radius, visible, "LeadDetailsSaleCompsTab");
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(
        useMemo(() => computed(() => saleCompStore.saleComps.filter(sc => circle.isPointInside(sc.centerPoint))), [circle]).get()
    ));

    useEffect(() => setEntityCount(saleComps.length), [saleComps]);

    if (!visible)
        return null;

    return (
        <SaleCompsGrid
            saleComps={saleComps}
            additionalHeaders={[{
                titleStrings: ["DISTANCE"],
                getValue: item => circle!.getDistanceFromCenter(item.centerPoint),
                getLabel: item => {
                    const distance = circle!.getDistanceFromCenter(item.centerPoint);
                    return distance ? formatNumber(distance) : "";
                }
            }]}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(LeadDetailsSaleCompsTab);
